/* eslint-disable @typescript-eslint/no-explicit-any */

export function htmlSpecialChars(unsafe: string | undefined) {
    return unsafe && unsafe.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

/**
 * Downloads a blob from a URL using native fetch API
 * @param url - URL to download from
 * @returns Promise with response containing blob data
 */
export function downloadBlob(url: string) {
    return fetch(url).then(async (response) => {
        if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
        }
        const blob = await response.blob();
        return {
            data: blob,
            status: response.status,
            statusText: response.statusText,
            headers: response.headers,
        };
    });
}

export function generateQueryString(parameters: Record<string, any>) {
    if (!parameters) {
        return '';
    }
    return Object.entries(parameters)
        .filter(([, v]) => v !== undefined && v !== null && v !== '')
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
}

export function appendQueryParameters(url: string, parameters: Record<string, any>) {
    const query = generateQueryString(parameters);
    if (!query) {
        return url;
    }
    return `${url}${url.includes('?') ? '&' : '?'}${query}`;
}
